import Immutable from 'immutable';
import React from 'react';
import Card from '../components/card';
import Checkbox from '../components/Checkbox';
import { lightGray } from '../shared/theme';
import { LoanCard } from './card-lenses';

const PROPERTY = 'lastFinancingExperience';

// all the properties that can be set by this card
export const prefills = [
  'Felt Pressured by Loan Officer',
  'Options were hard to understand',
  "Wasn't sure I made the right choice",
  'Too much/too little communication',
  'Other'
];

export const nothing = 'None, it was great!';

const isNoneSelectedInModel = (model) => {
  const field = model.get(PROPERTY);
  return field && (field.size === 0 || (field.size === 1 && field.has(nothing)));
};

const hasSelection = (prefill, model) => {
  const field = model.get(PROPERTY);
  return field && field.has(prefill);
};

class LastExperienceImpl extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      noneSelected: isNoneSelectedInModel(props.model)
    };
    this.onChange = this.onChange.bind(this);
    this.noneClicked = this.noneClicked.bind(this);
  }

  componentWillReceiveProps({ model }) {
    this.setState({
      noneSelected: isNoneSelectedInModel(model)
    });
  }

  onChange(prefill, checked) {
    let field = this.props.model.get(PROPERTY);
    if (!field) {
      if (checked) {
        field = Immutable.Set([prefill]);
        this.setState({
          noneSelected: false
        });
      } else {
        field = Immutable.Set([nothing]);
        this.setState({
          noneSelected: true
        });
      }
    } else {
      if (checked) {
        field = field.add(prefill);
        field = field.delete(nothing);
      } else {
        field = field.delete(prefill);
      }
      if (field.length === 0) {
        field = Immutable.Set([nothing]);
        this.setState({
          noneSelected: true
        });
      } else {
        this.setState({
          noneSelected: false
        });
      }
    }
    this.props.onChange(PROPERTY, field);
  }

  noneClicked(value) {
    if (value) {
      this.props.onChange(PROPERTY, Immutable.Set([nothing]));
    }
    this.setState({
      // This cannot be unchecked by clicking on it.
      noneSelected: true
    });
  }

  render() {
    const { model, onChange: _, ...cardProps } = this.props;
    return (
      <Card
        buttonType="complete"
        title={'What were the least desirable aspects of your last home financing experience?'}
        {...cardProps}
      >
        {prefills.map((prefill, i) => (
          <Checkbox
            key={i}
            style={{ marginTop: '0.5em' }}
            label={prefill}
            value={hasSelection(prefill, model)}
            onChange={(value) => this.onChange(prefill, value)}
          />
        ))}
        <hr style={{ borderColor: lightGray, borderStyle: 'solid' }} />
        <Checkbox
          style={{ marginTop: '0.5em' }}
          label={nothing}
          value={this.state.noneSelected}
          onChange={this.noneClicked}
        />
      </Card>
    );
  }
}

LastExperienceImpl.completed = ({ model }) => model.get(PROPERTY);

LastExperienceImpl.id = 'LastExperience';

export const LastExperience = LoanCard(LastExperienceImpl);



// WEBPACK FOOTER //
// ./src/cards/last-experience.js